import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "delete_account.png",
    width: 920,
    height: 515
});